import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar,
} from "../../../../../../_metronic/_partials/controls";
import { useSubheader } from "../../../../../../_metronic/layout";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import * as actions from "../../../_redux/invoices/invoicesActions";
import InvoiceEditForm from "./InvoiceEditForm";
import { toast } from "react-hot-toast";

export function InvoiceEdit({
  history,
  match: {
    params: { id },
  },
}) {
  const backToInvoicesList = () => {
    history.push(`/accounting/invoices/${id}`);
  };

  const subHeader = useSubheader();

  const [title, setTitle] = useState("");
  const dispatch = useDispatch();

  const { actionsLoading, invoiceToView } = useSelector(
    (state) => ({
      actionsLoading: state.invoices.actionsLoading,
      invoiceToView: state.invoices.invoiceToView,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchInvoice(id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = `ویرایش فاکتور ${invoiceToView?.name ?? ""}`;
    setTitle(_title);

    subHeader.setTitle(_title);
  }, [invoiceToView, id]);

  const saveInvoice = (values) => {
    dispatch(actions.updateInvoice(values))
      .then(() => {
        backToInvoicesList();
        toast.success("فاکتور با موفقیت تغییر کرد");
      })
      .catch(() => {
        toast.error("خطا در تغییر فاکتور");
      });
  };

  const btnRef = useRef();

  const saveInvoiceClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type={"button"}
            onClick={backToInvoicesList}
            className={"btn btn-light"}
          >
            <i className={"fa fa-arrow-left"} />
            برگشت
          </button>
          <> </>
          <button
            type={"button"}
            className={"btn btn-primary ml-2"}
            onClick={saveInvoiceClick}
          >
            ذخیره
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <InvoiceEditForm
          invoices={invoiceToView}
          btnRef={btnRef}
          saveInvoice={saveInvoice}
        />
      </CardBody>
    </Card>
  );
}
